import { AppState } from "@configs/store/rootReducer";
import { Snackbar, Alert } from "@mui/material";
import { openToast } from "@redux/toast/actions";
import React from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
export default function Toast(){
    const toast = useSelector((state: AppState) => state.toOpen);
    
    const dispatch = useDispatch();

    const handleCloseToast = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
          return; 
        }
        dispatch(openToast({
                    text: "",
                    open: false
                  }))
      }
      return (
        <>
          <Snackbar open={toast.open} autoHideDuration={6000} onClose={handleCloseToast}>
            <Alert onClose={handleCloseToast} severity={toast.severity} sx={{ width: '100%' }}>
              {toast.text}
            </Alert>
          </Snackbar>
        </>
      )
}